angular
  .module('common.directives')
  .directive('healthReportsDataUsage', function () {
    return {
      templateUrl:
        './templates/health-reports/health-reports-data-usage.view.html?t=' +
        webpackHash,
      link: function ($scope, $element) {},
      controller: 'healthReportsDataUsageController'
    }
  })
